import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { DollarSign, Calendar, Shield, TrendingUp, Users, Clock } from 'lucide-react';

const BecomeMobilitier = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const benefits = [
    { icon: DollarSign, title: 'Genera Ingresos Extra', description: 'Gana hasta $15,000 MXN al mes rentando tu auto cuando no lo uses.', color: 'bg-green-100 text-green-600' },
    { icon: Calendar, title: 'Tú Decides Cuándo', description: 'Control total sobre fechas disponibles. Pausa cuando quieras.', color: 'bg-blue-100 text-blue-600' },
    { icon: Shield, title: 'Pagos Seguros', description: 'Recibe pagos directamente en tu cuenta bancaria vía Stripe.', color: 'bg-purple-100 text-purple-600' },
    { icon: TrendingUp, title: 'Maximiza tu Inversión', description: 'Tu auto genera dinero en lugar de solo depreciarse.', color: 'bg-orange-100 text-orange-600' },
    { icon: Users, title: 'Comunidad Confiable', description: 'Todos los usuarios verificados con licencia antes de rentar.', color: 'bg-pink-100 text-pink-600' },
    { icon: Clock, title: 'Proceso Rápido', description: 'Publica tu auto en 10 minutos. Empieza a ganar hoy.', color: 'bg-yellow-100 text-yellow-600' }
  ];

  const handleGetStarted = () => {
    if (user) {
      if (user.role === 'mobilitier') {
        navigate('/mobilitier/dashboard');
      } else {
        navigate('/signup');
      }
    } else {
      navigate('/signup');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <section className="relative bg-gradient-to-r from-[#000000] to-[#5B7FFF] text-white py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6">
                Convierte tu auto en tu fuente de ingresos
              </h1>
              <p className="text-xl mb-8 opacity-90">
                Únete a la comunidad de Mobilitiers y genera hasta $15,000 MXN al mes rentando tu auto cuando no lo uses.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button size="lg" className="bg-[#bcef3c] hover:bg-[#a8d92e] text-gray-900 font-semibold text-lg px-8" onClick={handleGetStarted}>
                  Empezar Ahora - Gratis
                </Button>
                <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" onClick={() => navigate('/how-it-works')}>
                  ¿Cómo funciona?
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">¿Por qué ser Mobilitier?</h2>
            <p className="text-xl text-gray-600">Beneficios que transformarán tu auto en un activo</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <Card key={index} className="hover:shadow-xl transition-shadow">
                <CardContent className="p-8">
                  <div className={`w-16 h-16 ${benefit.color} rounded-full flex items-center justify-center mb-6`}>
                    <benefit.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-3">{benefit.title}</h3>
                  <p className="text-gray-600 text-lg">{benefit.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-[#000000] to-[#5B7FFF] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            ¿Listo para empezar a ganar?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Únete a cientos de Mobilitiers que ya generan ingresos pasivos con sus autos.
          </p>
          <Button size="lg" className="bg-[#bcef3c] hover:bg-[#a8d92e] text-gray-900 font-bold text-xl px-12 py-6" onClick={handleGetStarted}>
            Crear mi cuenta gratis
          </Button>
          <p className="mt-6 text-sm opacity-75">Sin costos iniciales. Cancela cuando quieras.</p>
        </div>
      </section>
    </div>
  );
};

export default BecomeMobilitier;
